export default __webpack_public_path__ + "media/images/avatars/avatar14-59ab53c7d0bc7c862cd80401cb7c0c35.png";